var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"progress-circular",style:(_vm.computedColor)},[_c('span',{staticClass:"loader"}),_c('span',{staticClass:"loader-aux"})])}
var staticRenderFns = []

export { render, staticRenderFns }